import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider } from 'react-i18next';
export function TranslationProvider({ i18n, children, }) {
    if (!i18n) {
        return _jsx(_Fragment, { children: children });
    }
    return _jsx(I18nextProvider, { i18n: i18n, children: children });
}
